import { render } from "./EnergyDataTable.vue?vue&type=template&id=61a8d0b8&scoped=true"
import script from "./EnergyDataTable.vue?vue&type=script&lang=js"
export * from "./EnergyDataTable.vue?vue&type=script&lang=js"

import "./EnergyDataTable.vue?vue&type=style&index=0&id=61a8d0b8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a8d0b8"]])

export default __exports__